import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { MonouChatModule, REPO_BOT_CONFIG } from '@monou/repo-bot-lib';

import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

// Registrar datos de localización español
registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MonouChatModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    {
      provide: REPO_BOT_CONFIG,
      useValue: {
        chatServiceUrl: environment.chatServiceUrl,
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
